<template>
  <span
    :class="`inline-flex items-center px-2 py-0.5 rounded text-sm font-medium ${twBg} ${twText}`"
    :title="title"
  >
    {{ label }}</span
  >
</template>

<script>
export default {
  name: "BadgeDefault",
  components: {},
  props: {
    label: { type: String },
    title: { type: String },
    twBg: { type: String, default: "bg-gray-100" },
    twText: { type: String, default: "text-gray-800" },
  },
  data() {
    return {};
  },
};
</script>
